import { $ } from './dom';

/* Toast */
export function showToast(msg: any){
  const t = $('toast');
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout((showToast as any)._t);
  (showToast as any)._t = setTimeout(()=> t.classList.remove('show'), 1500);
}
